import { z } from 'zod';
import { freeze } from '@reduxjs/toolkit';
import { ZodProperties } from '../../../../utils/zod';
import {
  FunnelDefaultConversionRateSetting,
  ICohortInspectFieldFieldsFragment,
  INestedFieldMetadata,
} from '../../../../utils/apollo/graphqlSchema';

const fieldSchema = z.object<ZodProperties<ICohortInspectFieldFieldsFragment>>({
  __typename: z.literal('Field'),
  name: z.string(),
  key: z.string(),
  isFactField: z.boolean(),
  nestedFieldMetadata: z
    .object<ZodProperties<Pick<INestedFieldMetadata, '__typename' | 'key'>>>({
      __typename: z.literal('NestedFieldMetadata'),
      key: z.string(),
    })
    .passthrough()
    .nullable(),
});

const schemaInspectSettingEditInputSchema = z.object({
  fields: z.array(fieldSchema).min(1, 'At least one field is required'),
  schemaKey: z.string().min(1, 'Schema is required'),
});

const funnelReportSettingSchema = z.object({
  defaultConversionRate: z.nativeEnum(FunnelDefaultConversionRateSetting),
});
const cohortInspectReportSettingSchema = z.object({
  schemaInspectSettings: z.array(schemaInspectSettingEditInputSchema),
});

export const reportSettingsSchema = z.object({
  funnel: funnelReportSettingSchema,
  inspect: cohortInspectReportSettingSchema,
});

export type ISchemaInspectSettingValue = z.infer<
  typeof schemaInspectSettingEditInputSchema
>;
export type IReportSettingsFormState = z.infer<typeof reportSettingsSchema>;

export const defaultSchemaInspectSettingValue =
  freeze<ISchemaInspectSettingValue>(
    {
      fields: [],
      schemaKey: '',
    },
    true,
  );
